const deliveryRouteMap = {
  "San José": {
    "San José": {
      "Carmen": "Ruta 1",
      "Merced": "Ruta 1",
      "Hospital": "Ruta 1",
      "Catedral": "Ruta 1",
      "Zapote": "Ruta 1",
      "San Francisco de Dos Ríos": "Ruta 1",
      "Uruca": "Ruta 1",
      "Mata Redonda": "Ruta 1",
      "Pavas": "Ruta 1",
      "Hatillo": "Ruta 1",
      "San Sebastián": "Ruta 1"
    },
    "Escazú": {
      "Escazú": "Ruta 1",
      "San Antonio": "Ruta 1",
      "San Rafael": "Ruta 1"
    },
    "Desamparados": {
      "Desamparados": "Ruta 1",
      "San Miguel": "Ruta 1",
      "San Juan de Dios": "Ruta 1",
      "San Rafael Arriba": "Ruta 1",
      "San Antonio": "Ruta 1",
      "Frailes": "Ruta 2",
      "Patarra": "Ruta 1",
      "San Cristobal": "Ruta 2",
      "Rosario": "Ruta 2",
      "Damas": "Ruta 1",
      "San Rafael Abajo": "Ruta 1",
      "Gravilias": "Ruta 1",
      "Los Guido": "Ruta 3"
    },
    "Puriscal": {
      "Santiago": "Ruta 2",
      "Mercedes Sur": "Ruta 2",
      "Barbacoas": "Ruta 2",
      "Grifo Alto": "Ruta 2",
      "San Rafael": "Ruta 2",
      "Candelarita": "Ruta 2",
      "Desamparaditos": "Ruta 2",
      "San Antonio": "Ruta 2",
      "Chires": "Ruta 2"
    },
    "Tarrazú": {
      "San Marcos": "Ruta 3",
      "San Lorenzo": "Ruta 3",
      "San Carlos": "Ruta 3"
    },
    "Aserrí": {
      "Aserrí": "Ruta 1",
      "Tarbaca": "Ruta 3",
      "Vuelta de Jorco": "Ruta 3",
      "San Gabriel": "Ruta 3",
      "Legua": "Ruta 3",
      "Monterrey": "Ruta 3",
      "Salitrillos": "Ruta 1"
    },
    "Mora": {
      "Colón": "Ruta 1",
      "Guayabo": "Ruta 2",
      "Tabarcia": "Ruta 2",
      "Piedras Negras": "Ruta 2",
      "Picagres": "Ruta 2",
      "Jaris": "Ruta 2",
      "Quitirrisí": "Ruta 2"
    },
    "Goicoechea": {
      "Guadalupe": "Ruta 1",
      "San Francisco": "Ruta 1",
      "Calle Blancos": "Ruta 1",
      "Mata de Plátano": "Ruta 1",
      "Ipis": "Ruta 1",
      "Rancho Redondo": "Ruta 1",
      "Purral": "Ruta 1"
    },
    "Santa Ana": {
      "Santa Ana": "Ruta 1",
      "Salitral": "Ruta 1",
      "Pozos": "Ruta 1",
      "Uruca": "Ruta 1",
      "Piedades": "Ruta 1",
      "Brasil": "Ruta 1"
    },
    "Alajuelita": {
      "Alajuelita": "Ruta 1",
      "San Josecito": "Ruta 1",
      "San Antonio": "Ruta 1",
      "Concepción": "Ruta 1",
      "San Felipe": "Ruta 1"
    },
    "Vazquez de Coronado": {
      "San Isidro": "Ruta 1",
      "San Rafael": "Ruta 1",
      "Dulce Nombre de Jesús": "Ruta 1",
      "Patalillo": "Ruta 1",
      "Cascajal": "Ruta 1"
    },
    "Acosta": {
      "San Ignacio": "Ruta 3",
      "Guaitil": "Ruta 3",
      "Palmichal": "Ruta 3",
      "Cangrejal": "Ruta 3",
      "Sabanillas": "Ruta 3"
    },
    "Tibás": {
      "San Juan": "Ruta 1",
      "Cinco Esquinas": "Ruta 1",
      "Anselmo Llorente": "Ruta 1",
      "León XIII": "Ruta 4",
      "Colima": "Ruta 1"
    },
    "Moravia": {
      "San Vicente": "Ruta 1",
      "San Jerónimo": "Ruta 1",
      "La Trinidad": "Ruta 1"
    },
    "Montes de Oca": {
      "San Pedro": "Ruta 1",
      "Sabanilla": "Ruta 1",
      "Mercedes": "Ruta 1",
      "San Rafael": "Ruta 1"
    },
    "Turrubares": {
      "San Pablo": "Ruta 3",
      "San Pedro": "Ruta 3",
      "San Juan de Mata": "Ruta 3",
      "San Luis": "Ruta 3",
      "Carara": "Ruta 3"
    },
    "Dota": {
      "Santa María": "Ruta 3",
      "Jardín": "Ruta 3",
      "Copey": "Ruta 3"
    },
    "Curridabat": {
      "Curridabat": "Ruta 1",
      "Granadilla": "Ruta 1",
      "Sánchez": "Ruta 1",
      "Tirrases": "Ruta 1"
    },
    "Pérez Zeledón": {
      "San Isidro de El General": "Ruta 3",
      "El General": "Ruta 3",
      "Daniel Flores": "Ruta 3",
      "Rivas": "Ruta 3",
      "San Pedro": "Ruta 3",
      "Platanares": "Ruta 3",
      "Pejibaye": "Ruta 3",
      "Cajón": "Ruta 3",
      "Barú": "Ruta 3",
      "Río Nuevo": "Ruta 3",
      "Paramo": "Ruta 3",
      "La  Amistad": "Ruta 3"
    },
    "León Cortés Castro": {
      "San Pablo": "Ruta 3",
      "San Andrés": "Ruta 3",
      "Llano Bonito": "Ruta 3",
      "San Isidro": "Ruta 3",
      "Santa Cruz": "Ruta 3",
      "San Antonio": "Ruta 3"
    }
  },
  "Cartago": {
    "Cartago": {
      "Oriental": "Ruta 1",
      "Occidental": "Ruta 1",
      "Carmen": "Ruta 1",
      "San Nicolás": "Ruta 1",
      "Aguacaliente o San Francisco": "Ruta 1",
      "Guadalupe o Arenilla": "Ruta 1",
      "Corralillo": "Ruta 2",
      "Tierra Blanca": "Ruta 1",
      "Dulce Nombre": "Ruta 1",
      "Llano Grande": "Ruta 1",
      "Quebradilla": "Ruta 1"
    },
    "Paraíso": {
      "Paraíso": "Ruta 1",
      "Santiago": "Ruta 1",
      "Orosi": "Ruta 1",
      "Cachí": "Ruta 1",
      "Llanos de Santa Lucía": "Ruta 1",
      "Birrisito": "Ruta 1"
    },
    "La Unión": {
      "Tres Ríos": "Ruta 1",
      "San Diego": "Ruta 1",
      "San Juan": "Ruta 1",
      "San Rafael": "Ruta 1",
      "Concepción": "Ruta 1",
      "Dulce Nombre": "Ruta 1",
      "San Ramón": "Ruta 1",
      "Río Azul": "Ruta 1"
    },
    "Jiménez": {
      "Juan Viñas": "Ruta 2",
      "Tucurrique": "Ruta 2",
      "Pejibaye": "Ruta 2"
    },
    "Turrialba": {
      "Turrialba": "Ruta 3",
      "La Suiza": "Ruta 3",
      "Peralta": "Ruta 3",
      "Santa Cruz": "Ruta 3",
      "Santa Teresita": "Ruta 3",
      "Pavones": "Ruta 3",
      "Tuis": "Ruta 3",
      "Tayutic": "Ruta 3",
      "Santa Rosa": "Ruta 3",
      "Tres Equis": "Ruta 3",
      "La Isabel": "Ruta 4",
      "Chirripó": "Ruta 4"
    },
    "Alvarado": {
      "Pacayas": "Ruta 1",
      "Cervantes": "Ruta 1",
      "Capellades": "Ruta 1"
    },
    "Oreamuno": {
      "San Rafael": "Ruta 1",
      "Cot": "Ruta 1",
      "Potrero Cerrado": "Ruta 1",
      "Cipreses": "Ruta 1",
      "Santa Rosa": "Ruta 1"
    },
    "El Guarco": {
      "El Tejar": "Ruta 1",
      "San Isidro": "Ruta 1",
      "Tobosi": "Ruta 1",
      "Patio de Agua": "Ruta 1"
    }
  },
  "Alajuela": {
    "Alajuela": {
      "Alajuela": "Ruta 1",
      "San José": "Ruta 1",
      "Carrizal": "Ruta 1",
      "San Antonio": "Ruta 1",
      "Guácima": "Ruta 1",
      "San Isidro": "Ruta 1",
      "Sabanilla": "Ruta 1",
      "San Rafael": "Ruta 1",
      "Río Segundo": "Ruta 1",
      "Desamparados": "Ruta 1",
      "Turrucares": "Ruta 1",
      "Tambor": "Ruta 1",
      "Garita": "Ruta 1",
      "Sarapiquí": "Ruta 2"
    },
    "San Ramón": {
      "San Ramón": "Ruta 1",
      "Santiago": "Ruta 1",
      "San Juan": "Ruta 1",
      "Piedades Norte": "Ruta 1",
      "Piedades Sur": "Ruta 1",
      "San Rafael": "Ruta 1",
      "San Isidro": "Ruta 1",
      "Ángeles": "Ruta 1",
      "Alfaro": "Ruta 1",
      "Volio": "Ruta 1",
      "Concepción": "Ruta 1",
      "Zapotal": "Ruta 1",
      "Peñas Blancas": "Ruta 2",
      "San Lorenzo": "Ruta 1"
    },
    "San Mateo": {
      "Labrador": "Ruta 1",
      "San Mateo": "Ruta 2",
      "Desmonte": "Ruta 2",
      "Jesús María": "Ruta 2"
    },
    "Grecia": {
      "Grecia": "Ruta 1",
      "San Isidro": "Ruta 1",
      "San José": "Ruta 1",
      "San Roque": "Ruta 1",
      "Tacares": "Ruta 1",
      "Puente de Piedra": "Ruta 1",
      "Bolivar": "Ruta 1"
    },
    "Atenas": {
      "Atenas": "Ruta 1",
      "Jesús": "Ruta 1",
      "Mercedes": "Ruta 1",
      "San Isidro": "Ruta 1",
      "Concepción": "Ruta 1",
      "San José": "Ruta 1",
      "Santa Eulalia": "Ruta 1",
      "Escobal": "Ruta 1"
    },
    "Naranjo": {
      "Naranjo": "Ruta 1",
      "San Miguel": "Ruta 1",
      "San José": "Ruta 1",
      "Cirrí Sur": "Ruta 1",
      "San Jerónimo": "Ruta 1",
      "San Juan": "Ruta 1",
      "El Rosario": "Ruta 1",
      "Palmitos": "Ruta 1"
    },
    "Palmares": {
      "Palmares": "Ruta 1",
      "Zaragoza": "Ruta 1",
      "Buenos Aires": "Ruta 1",
      "Santiago": "Ruta 1",
      "Candelaria": "Ruta 1",
      "Esquipulas": "Ruta 1",
      "La Granja": "Ruta 1"
    },
    "Poás": {
      "San Pedro": "Ruta 1",
      "San Juan": "Ruta 1",
      "San Rafael": "Ruta 1",
      "Carrillos": "Ruta 1",
      "Sabana Redonda": "Ruta 1"
    },
    "Orotina": {
      "Orotina": "Ruta 2",
      "El Mastate": "Ruta 2",
      "Hacienda Vieja": "Ruta 2",
      "Coyolar": "Ruta 2",
      "La Ceiba": "Ruta 2"
    },
    "San Carlos": {
      "Quesada": "Ruta 3",
      "Florencia": "Ruta 3",
      "Buenavista": "Ruta 3",
      "Aguas Zarcas": "Ruta 3",
      "Venecia": "Ruta 3",
      "Pital": "Ruta 3",
      "La Fortuna": "Ruta 3",
      "La Tigra": "Ruta 3",
      "La Palmera": "Ruta 3",
      "Venado": "Ruta 3",
      "Cutris": "Ruta 3",
      "Monterrey": "Ruta 3",
      "Pocosol": "Ruta 3"
    },
    "Zarcero": {
      "Zarcero": "Ruta 3",
      "Laguna": "Ruta 3",
      "Tapezco": "Ruta 3",
      "Guadalupe": "Ruta 3",
      "Palmira": "Ruta 3",
      "Zapote": "Ruta 3",
      "Brisas": "Ruta 3"
    },
    "Río Cuarto": {
      "Santa Rita": "Ruta 3",
      "Santa Isabel": "Ruta 3",
      "Río Cuarto": "Ruta 3"
    },
    "Sarchí": {
      "Sarchí Norte": "Ruta 1",
      "Sarchí Sur": "Ruta 1",
      "Toro Amarillo": "Ruta 4",
      "San Pedro": "Ruta 1",
      "Rodríguez": "Ruta 1"
    },
    "Upala": {
      "Upala": "Ruta 3",
      "Aguas Claras": "Ruta 3",
      "San José O Pizote": "Ruta 3",
      "Bijagua": "Ruta 3",
      "Delicias": "Ruta 3",
      "Dos Ríos": "Ruta 3",
      "Canalete": "Ruta 3",
      "Yolillal": "Ruta 3"
    },
    "Los Chiles": {
      "Los Chiles": "Ruta 3",
      "Caño Negro": "Ruta 3",
      "El Amparo": "Ruta 3",
      "San Jorge": "Ruta 3"
    },
    "Guatuso": {
      "San Rafael": "Ruta 3",
      "Buenavista": "Ruta 3",
      "Cote": "Ruta 3",
      "Katira": "Ruta 3"
    }
  },
  "Heredia": {
    "Heredia": {
      "Heredia": "Ruta 1",
      "Mercedes": "Ruta 1",
      "San Francisco": "Ruta 1",
      "Ulloa": "Ruta 1",
      "Varablanca": "Ruta 2"
    },
    "Barva": {
      "Barva": "Ruta 1",
      "San Pedro": "Ruta 1",
      "San Pablo": "Ruta 1",
      "San Roque": "Ruta 1",
      "Santa Lucía": "Ruta 1",
      "San José de la Montaña": "Ruta 1"
    },
    "Santo Domingo": {
      "Santo Domingo": "Ruta 1",
      "San Vicente": "Ruta 1",
      "San Miguel": "Ruta 1",
      "Paracito": "Ruta 1",
      "Santo Tomás": "Ruta 1",
      "Santa Rosa": "Ruta 1",
      "Tures": "Ruta 1",
      "Pará": "Ruta 1"
    },
    "Santa Bárbara": {
      "Santa Bárbara": "Ruta 1",
      "San Pedro": "Ruta 1",
      "San Juan": "Ruta 1",
      "Jesús": "Ruta 1",
      "Santo Domingo": "Ruta 1",
      "Purabá": "Ruta 1"
    },
    "San Rafael": {
      "San Rafael": "Ruta 1",
      "San Josecito": "Ruta 1",
      "Santiago": "Ruta 1",
      "Ángeles": "Ruta 1",
      "Concepción": "Ruta 1"
    },
    "San Isidro": {
      "San Isidro": "Ruta 1",
      "San José": "Ruta 1",
      "Concepción": "Ruta 1",
      "San Francisco": "Ruta 1"
    },
    "Belén": {
      "San Antonio": "Ruta 1",
      "La Ribera": "Ruta 1",
      "La Asunción": "Ruta 1"
    },
    "Flores": {
      "San Joaquín": "Ruta 1",
      "Barrantes": "Ruta 1",
      "Llorente": "Ruta 1"
    },
    "San Pablo": {
      "San Pablo": "Ruta 1",
      "Rincón de Sabanilla": "Ruta 1"
    },
    "Sarapiquí": {
      "Puerto Viejo": "Ruta 3",
      "La Virgen": "Ruta 3",
      "Las Horquetas": "Ruta 3",
      "Llanuras del Gaspar": "Ruta 3",
      "Cureña": "Ruta 3"
    }
  },
  "Guanacaste": {
    "Liberia": {
      "Liberia": "Ruta 3",
      "Cañas Dulces": "Ruta 3",
      "Mayorga": "Ruta 3",
      "Nacascolo": "Ruta 3",
      "Curubandé": "Ruta 3"
    },
    "Nicoya": {
      "Nicoya": "Ruta 3",
      "Mansión": "Ruta 3",
      "San Antonio": "Ruta 3",
      "Quebrada Honda": "Ruta 3",
      "Sámara": "Ruta 3",
      "Nosara": "Ruta 3",
      "Belén de Nosarita": "Ruta 3"
    },
    "Santa Cruz": {
      "Santa Cruz": "Ruta 3",
      "Bolsón": "Ruta 3",
      "Veintisiete de Abril": "Ruta 3",
      "Tempate": "Ruta 3",
      "Cartagena": "Ruta 3",
      "Cuajiniquil": "Ruta 3",
      "Diriá": "Ruta 3",
      "Cabo Velas": "Ruta 3",
      "Tamarindo": "Ruta 3"
    },
    "Bagaces": {
      "Bagaces": "Ruta 3",
      "La Fortuna": "Ruta 3",
      "Mogote": "Ruta 3",
      "Río Naranjo": "Ruta 3"
    },
    "Carrillo": {
      "Filadelfia": "Ruta 3",
      "Palmira": "Ruta 3",
      "Sardinal": "Ruta 3",
      "Belén": "Ruta 3"
    },
    "Cañas": {
      "Cañas": "Ruta 3",
      "Palmira": "Ruta 3",
      "San Miguel": "Ruta 3",
      "Bebedero": "Ruta 3",
      "Porozal": "Ruta 3"
    },
    "Abangares": {
      "Las Juntas": "Ruta 3",
      "Sierra": "Ruta 3",
      "San Juan": "Ruta 3",
      "Colorado": "Ruta 3"
    }
  },
  "Puntarenas": {
    "Puntarenas": {
      "Puntarenas": "Ruta 2",
      "Pitahaya": "Ruta 4",
      "Chomes": "Ruta 3",
      "Lepanto": "Ruta 4",
      "Paquera": "Ruta 3",
      "Manzanillo": "Ruta 4",
      "Guacimal": "Ruta 4",
      "Barranca": "Ruta 3",
      "Isla del Coco": "Ruta 4",
      "Cóbano": "Ruta 3",
      "Chacarita": "Ruta 3",
      "Chira": "Ruta 4",
      "Acapulco": "Ruta 3",
      "El Roble": "Ruta 2",
      "Arancibia": "Ruta 3"
    },
    "Esparza": {
      "Espíritu Santo": "Ruta 2",
      "San Juan Grande": "Ruta 2",
      "Macacona": "Ruta 2",
      "San Rafael": "Ruta 2",
      "San Jerónimo": "Ruta 2",
      "Caldera": "Ruta 2"
    },
    "Buenos Aires": {
      "Buenos Aires": "Ruta 3",
      "Volcán": "Ruta 3",
      "Potrero Grande": "Ruta 3",
      "Boruca": "Ruta 4",
      "Pilas": "Ruta 4",
      "Colinas": "Ruta 4",
      "Chánguena": "Ruta 4",
      "Biolley": "Ruta 4",
      "Brunka": "Ruta 4"
    },
    "Montes de Oro": {
      "Miramar": "Ruta 3",
      "La Unión": "Ruta 3",
      "San Isidro": "Ruta 3"
    },
    "Osa": {
      "Puerto Cortés": "Ruta 3",
      "Palmar": "Ruta 3",
      "Sierpe": "Ruta 3",
      "Bahía Ballena": "Ruta 3",
      "Piedras Blancas": "Ruta 3",
      "Bahía Drake": "Ruta 3"
    },
    "Quepos": {
      "Quepos": "Ruta 3",
      "Savegre": "Ruta 3",
      "Naranjito": "Ruta 4"
    },
    "Golfito": {
      "Golfito": "Ruta 3",
      "Puerto Jiménez": "Ruta 3",
      "Guaycará": "Ruta 3",
      "Pavón": "Ruta 3"
    },
    "Coto Brus": {
      "San Vito": "Ruta 3",
      "Sabalito": "Ruta 3",
      "Aguabuena": "Ruta 3",
      "Limoncito": "Ruta 3",
      "Pittier": "Ruta 3",
      "Gutiérrez Braun": "Ruta 3"
    },
    "Parrita": {
      "Parrita": "Ruta 3"
    },
    "Corredores": {
      "Corredor": "Ruta 3",
      "La Cuesta": "Ruta 3",
      "Canoas": "Ruta 3",
      "Laurel": "Ruta 3"
    },
    "Garabito": {
      "Jacó": "Ruta 3",
      "Tárcoles": "Ruta 3",
      "Lagunillas": "Ruta 3"
    },
    "Monteverde": {
      "Monteverde": "Ruta 4"
    }
  },
  "Limón": {
    "Limón": {
      "Limón": "Ruta 3",
      "Valle La Estrella": "Ruta 3",
      "Río Blanco": "Ruta 4",
      "Matama": "Ruta 3"
    },
    "Pococí": {
      "Guápiles": "Ruta 3",
      "Jiménez": "Ruta 3",
      "Rita": "Ruta 3",
      "Roxana": "Ruta 3",
      "Cariari": "Ruta 3",
      "Colorado": "Ruta 4",
      "La Colonia": "Ruta 3"
    },
    "Siquirres": {
      "Siquirres": "Ruta 3",
      "Pacuarito": "Ruta 3",
      "Florida": "Ruta 3",
      "Germania": "Ruta 3",
      "El Cairo": "Ruta 3",
      "Alegría": "Ruta 3",
      "Reventazón": "Ruta 3"
    },
    "Talamanca": {
      "Bratsi": "Ruta 3",
      "Sixaola": "Ruta 3",
      "Cahuita": "Ruta 3",
      "Telire": "Ruta 4"
    },
    "Matina": {
      "Matina": "Ruta 3",
      "Batán": "Ruta 3",
      "Carrandí": "Ruta 3"
    },
    "Guácimo": {
      "Guácimo": "Ruta 3",
      "Mercedes": "Ruta 3",
      "Pocora": "Ruta 3",
      "Río Jiménez": "Ruta 3",
      "Duacarí": "Ruta 3"
    }
  }
};